/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const CURRENT_USER_STRIKES = graphql(`
  query currentUser {
    currentUser {
      _id
      roles {
        _id
        role
      }
      has_volo_pass
      player_strikes_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`);
